module.exports = __webpack_public_path__ + "static/media/The journey through the woods.4bf24bc8.jpg";